module.exports={render:function (){var _vm=this;
  return _vm._h('div', {
    staticClass: "panel panel-default"
  }, [_vm._h('drug-view', {
    attrs: {
      "drug": _vm.drug,
      "patient": _vm.patient,
      "favs": _vm.favs,
      "id": _vm.modalId
    }
  }), " ", _vm._h('div', {
    staticClass: "panel-body"
  }, [_vm._h('form', [_vm._h('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.filter),
      expression: "filter"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "placeholder": "Filter drugs by name"
    },
    domProps: {
      "value": _vm._s(_vm.filter)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.filter = $event.target.value
      }
    }
  })])]), " ", _vm._h('div', {
    staticClass: "list-group"
  }, [_vm._l((_vm.bigList), function(item) {
    return [_vm._h('button', {
      staticClass: "list-group-item",
      attrs: {
        "type": "button"
      },
      on: {
        "click": function($event) {
          _vm.launchModal(item)
        }
      }
    }, [_vm._s(item)])]
  })])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-581d0792!./~/vue-loader/lib/selector.js?type=template&index=0!./src/ListView.vue
// module id = 145
// module chunks = 0